export default {
  getWorld () {
    return new Promise((resolve, reject) =>
      setTimeout(
        () => resolve('world'),
        1000
      )
    )
  }
}



// WEBPACK FOOTER //
// ./src/api/hello.js